import React from 'react';
import styled from 'styled-components';
import { HashLink } from 'react-router-hash-link';
import Icon from './Icon';

const theme = `
  --link-active-color: var(--deep-work);
  --link-color: var(--blurple);
  --link-focus-outline-color: var(--blues-cues);
  --link-font-weight: var(--bold);
  --link-hover-color: var(--deep-work);
  --link-text-decoration: underline;
  --link-visited-color: var(--link-active-color);
`;

const Base = styled.a`
  ${theme}

  cursor: pointer;
  font-weight: var(--link-font-weight);
  font-size: inherit;
  line-height: 1.5;
  color: var(--link-color);
  text-decoration: none;
  text-decoration-color: inherit;

  > ${Icon} {
    margin-left: 8px;
    margin-right: 4px;
  }

  &:hover {
    color: var(--link-hover-color);
    text-decoration: var(--link-text-decoration);
  }

  &:focus-visible {
    border-radius: 6px;
    box-shadow: 0 0 0 2px var(--link-focus-outline-color);
    outline: none;
  }

  &:active {
    color: var(--link-active-color);
    text-decoration: var(--link-text-decoration);
  }

  &:visited {
    color: var(--link-visited-color);

    > ${Icon} {
      color: var(--link-visited-color);
    }
  }
`;

export const Link = styled(Base).attrs(({ to }) => ({
  as: to ? HashLink : 'a',
}))``;

export const ExternalLink = styled(Base).attrs(({ children, icon = true }) => ({
  rel: 'noopener noreferrer',
  target: '_blank',
  children: (
    <>
      {children}
      {icon && <Icon icon="external-link-alt" />}
    </>
  ),
}))``;

export default Link;
